/// <amd-module name="Test/TestReportingSignalR/TestHubProxies" />
import { jqueryShimmed } from "VSS/Features/SignalR/3rdParty/jquery.shimmed";
import { registerProxy } from "VSS/Features/SignalR/HubProxies";
import { ISignalRHubProxy } from "VSS/Features/SignalR/HubProxies.types";

export namespace HubNames {
    export const testHub = "testHub";
}

export interface ITestSignalRHubServer {
    watchRelease: (releaseId: number, releaseEnvironmentId: number) => Promise<void>;
    unwatchRelease: (releaseId: number, releaseEnvironmentId: number) => Promise<void>;
    watchBuild: (buildId: number) => Promise<void>;
    unwatchBuild: (buildId: number) => Promise<void>;
}

export interface ITestSignalRHubClient {
    testRunStatsChangedForBuild: (buildId: number) => void;
    testRunStatsChangedForRelease: (releaseId: number, releaseEnvironmentId: number) => void;
}

export function getTestSignalRHubProxyToRegister<C, S>(baseProxy: ISignalRHubProxy<any, any>): ISignalRHubProxy<C, S> {
    const $ = jqueryShimmed;
    baseProxy.server = {
        watchRelease: function(releaseId: number, releaseEnvironmentId: number) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["watchRelease"], $.makeArray(arguments)));
        },

        unwatchRelease: function(releaseId: number, releaseEnvironmentId: number) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["unWatchRelease"], $.makeArray(arguments)));
        },

        watchBuild: function(buildId: number) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["watchBuild"], $.makeArray(arguments)));
        },

        unwatchBuild: function(buildId: number) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["unWatchBuild"], $.makeArray(arguments)));
        }
    };

    return baseProxy;
}
